import { FC } from 'react';

export interface DetailPageEditProps {}

const DetailPageEdit: FC<DetailPageEditProps> = props => {
  return <div>编辑</div>;
};

export default DetailPageEdit;
